import { FaqProfileType } from '../models/faq-profile-type.model';

export const FAQ_PROFILE_TYPES: FaqProfileType[] = [
    {value: 'all', viewValue: 'tutti'},
    {value: 'teams', viewValue: 'squadre'},
    {value: 'players', viewValue: 'giocatori'},
    {value: 'coaches', viewValue: 'allenatori'}
];
